export default __webpack_public_path__ + "static/media/m_navBannerImg2.78584ae2.png";